import PackagesCards from './PackagesCards';

export default PackagesCards;
